import { windowUtils } from '@packages/domain/utils/windowUtils/windowUtils';
import {
  HCAPTCHA_SITE_KEY_DEV,
  HCAPTCHA_SITE_KEY_PROD,
  HCAPTCHA_SITE_KEY_STAGING,
  PROD_DOMAINS_FOR_CAPTCHA,
  STAGING_DOMAINS_FOR_CAPTCHA,
} from 'constants/config';

const getDomainName = () => {
  const hostName = windowUtils.getHostname();
  return hostName.substring(
    hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
  );
};

export const captchaKey = (() => {
  const domainName = getDomainName();
  if (PROD_DOMAINS_FOR_CAPTCHA.includes(domainName)) {
    return HCAPTCHA_SITE_KEY_PROD;
  }
  if (STAGING_DOMAINS_FOR_CAPTCHA.includes(domainName)) {
    return HCAPTCHA_SITE_KEY_STAGING;
  }
  return HCAPTCHA_SITE_KEY_DEV;
})();
